import { api as com, apiFuns } from 'sw-hic';
const { genStandard } = apiFuns;

let api = {
  Patient: com.Patient,
  Contact: genStandard('contact', '/api/patient'),
  Card: genStandard('card', '/api/patient'),
};
export default api;
